export default "__VITE_ASSET__f3bb2a09__"